/// <reference path="../interfaces/lightsliderconfig.ts" />
module Tapas.ViewModels {
    export class PopularProductsViewModel extends Ftw.ViewModels.BaseViewModel {

        public lightSliderConfig: LightSliderConfig;
        public lightSlider: JQuery; 

        constructor() {

            super();

            this.lightSlider = $();

            this.lightSliderConfig = {
                item: 4,
                loop: false,
                slideMove: 1,
                easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
                speed: 600,
                pager: false,
                controls: false,
                slideEndAnimation: false,
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: {
                            item: 3,
                            slideMove: 1,
                            slideMargin: 10
                        }
                    },
                    {
                        breakpoint: 800,
                        settings: {
                            item: 2,
                            slideMove: 1,
                            slideMargin: 6,
                        }
                    },
                    {
                        breakpoint: 580,
                        settings: {
                            item: 1,
                            slideMove: 1
                        }
                    }
                ]
            };
        }

        //NEW SLIDER CONTROLS - FUNCTIONS
        //NEXT
        public nextSlide() {
            this.lightSlider.goToNextSlide();
        }

        //PREV
        public prevSlide() {
            this.lightSlider.goToPrevSlide();
        }
    }
}